import React from "react";
import { FAQ, faqItems } from "../components/Sections";
import { useUpcomingShows } from "../lib/shows";
import PageHero from "../components/PageHero";
import Seo from "../components/seo/Seo";
import JsonLd from "../components/seo/JsonLd";
import { InterestCta, TextLink } from "../components/Bits";
import { Reveal } from "../components/Decorative";
import { ROUTES, breadcrumbs } from "../lib/seo";

function faqSchema(items) {
  return {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    mainEntity: items.map((f) => ({
      "@type": "Question",
      name: f.q,
      acceptedAnswer: { "@type": "Answer", text: f.a },
    })),
  };
}

export default function FaqPage() {
  const items = faqItems(useUpcomingShows());
  return (
    <>
      <Seo route={ROUTES.faq} />
      <JsonLd data={[faqSchema(items), breadcrumbs([{ name: ROUTES.faq.crumb, path: ROUTES.faq.path }])]} />

      <PageHero
        eyebrow="Questions"
        title={<>Everything you might <span className="gold-grad italic">ask</span></>}
        intro="Tickets, timing, reaching the venue, age and dress. If your question isn't here, message us on WhatsApp."
      >
        <p className="mt-3 font-body text-base" style={{ color: "#E8D9C5" }}>
          Still curious about the format? <TextLink to={ROUTES.pillar.path}><span style={{ color: "#E5C880" }}>What is bhajan jamming?</span></TextLink>
        </p>
      </PageHero>

      <FAQ />

      <section className="bg-cream py-20 md:py-28 px-6">
        <div className="max-w-3xl mx-auto text-center">
          <Reveal>
            <InterestCta note="We announce new dates to the list first." />
          </Reveal>
        </div>
      </section>
    </>
  );
}
